<mat-icon *ngIf="!isSorting" svgIcon="heroicons_outline:chevron-up-down"></mat-icon>
<ng-container *ngIf="isSorting">
    <mat-icon *ngIf="isAsc" svgIcon="custom:sort-chevron-down"></mat-icon>
    <mat-icon *ngIf="!isAsc" svgIcon="custom:sort-chevron-up"></mat-icon>
</ng-container>
